import { render } from "./DeletedSpecialities.vue?vue&type=template&id=2ec76484&scoped=true"
import script from "./DeletedSpecialities.vue?vue&type=script&lang=js"
export * from "./DeletedSpecialities.vue?vue&type=script&lang=js"

import "./DeletedSpecialities.vue?vue&type=style&index=0&id=2ec76484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec76484"]])

export default __exports__